import * as XState from 'xstate'
import * as Network from '@avcan/utils/dom/network'

export default XState.Machine({
    id: 'submit',
    initial: 'checking',
    states: {
        checking: {
            always: [
                {
                    target: 'online',
                    cond() {
                        return Network.getOnLine()
                    },
                },
                {
                    target: 'offline',
                },
            ],
        },
        online: {
            entry: XState.assign({
                completed() {
                    return new Set()
                },
            }),
            invoke: {
                id: 'offline',
                src() {
                    return callback => {
                        function listener() {
                            callback('OFFLINE')
                        }

                        window.addEventListener('offline', listener)

                        return () => {
                            window.removeEventListener('offline', listener)
                        }
                    }
                },
            },
            on: {
                OFFLINE: {
                    target: 'offline',
                    actions: XState.sendUpdate(),
                },
            },
            initial: 'authorization',
            states: {
                authorization: {
                    initial: 'checking',
                    states: {
                        checking: {
                            always: [
                                {
                                    target: 'success',
                                    cond: 'isAuthenticated',
                                },
                                {
                                    target: 'pending',
                                },
                            ],
                        },
                        pending: {
                            invoke: {
                                id: 'authenticate',
                                src: 'authenticate',
                                onDone: 'success',
                                onError: 'failure',
                            },
                        },
                        success: {
                            type: 'final',
                            entry: XState.assign({
                                completed(context) {
                                    return context.completed.add('authorization')
                                },
                            }),
                        },
                        failure: {
                            entry: XState.sendUpdate(),
                            on: {
                                RETRY: 'pending',
                            },
                        },
                    },
                    onDone: 'submission',
                },
                submission: {
                    entry: [
                        XState.sendUpdate(),
                        XState.assign({
                            retries() {
                                return 0
                            },
                        }),
                    ],
                    initial: 'pending',
                    states: {
                        pending: {
                            entry: XState.sendUpdate(),
                            invoke: {
                                id: 'save',
                                src: 'save',
                                onDone: 'success',
                                onError: 'failure',
                            },
                        },
                        success: {
                            type: 'final',
                            entry: XState.assign({
                                completed(context) {
                                    return context.completed.add('submission')
                                },
                            }),
                        },
                        failure: {
                            entry: [
                                XState.assign({
                                    error(context, event) {
                                        return event.data
                                    },
                                }),
                                XState.sendUpdate(),
                            ],
                            on: {
                                RETRY: {
                                    target: 'pending',
                                    actions: XState.assign({
                                        retries(context) {
                                            return context.retries + 1
                                        },
                                    }),
                                },
                            },
                        },
                    },
                    onDone: 'success',
                },
                success: {
                    type: 'final',
                },
            },
            onDone: 'success',
        },
        offline: {
            entry: XState.assign({
                completed() {
                    return new Set()
                },
            }),
            invoke: {
                id: 'online',
                src() {
                    return callback => {
                        function listener() {
                            callback('ONLINE')
                        }

                        window.addEventListener('online', listener)

                        return () => {
                            window.removeEventListener('online', listener)
                        }
                    }
                },
            },
            on: {
                ONLINE: {
                    target: 'online',
                    actions: XState.sendUpdate(),
                },
            },
        },
        success: {
            type: 'final',
            data: {
                submissionID(context, event) {
                    return event.data.submissionID
                },
            },
        },
    },
})
